export enum SiteComponentType {
    Header = 'header',
    Footer = 'footer'
}